import { hostingReducer } from "app/hostingReducer";
import AddToCartButton from "components/AddToCartButton";
import BillingCycleOptions from "components/BillingCycleOptions";
import CardWrapper from "components/CardWrapper";
import ServerOptions from "components/ServerOptions";
import PromoKaosTumbler from "components/PromoKaosTumbler";
import { Card, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown, faChevronUp, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import cpanelIcon from "assets/images/icons/cpanel.png";
import directAdminIcon from "assets/images/icons/directadmin.png";
import {
  addPaymentGateway,
  addPromo,
  addToCart,
  changeProductFromCart,
  removePromoCode,
  setQueryPromo,
  setPromoCode,
  addDomainToCart,
  addWhoisToCart,
  removeCartItem,
} from "features/common/layouts/cartSlice";
import {
  getProduct as getProdsByPID,
  getProductPromo,
  // removeCurrentProducts,
  selectProduct,
} from "features/common/products/productsSlice";
import { formatIDR, useQuery } from "helpers/utils";
import {
  getProducts,
  getProductsPromo,
  isNoDomain,
} from "features/hosting/hostingSlice";
import { getOnlyTLD } from "helpers/helper";
import MainLayouts from "layouts/MainLayouts";
import ExistingDomain from "pages/Domain/ExistingDomain";
import RegisterDomain from "pages/Domain/RegisterDomain";
import TransferDomain from "pages/Domain/TransferDomain";
import { useCallback, useEffect, useReducer, useRef, useState } from "react";
import { Placeholder } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import HPCHOrder from "./HPCHOrder";
import UnlimitedHostingOrder from "./UnlimitedHostingOrder";
import VCHOrder from "./VCHOrder";
import WordpressOrder from "./WordpressOrder";
import { useLocation } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import CloudHosting from "./CloudHosting";
import { notifySuccess, notifyError } from "components/ToastMessage";
import { setOrderParams } from "features/common/layouts/cartSlice";
import CheckboxNewHosting from 'components/CheckboxNewHosting';
import { calculateHemat, calculateHematFallback } from 'helpers/hematCalculator';
// import ProductDropdownNewHosting from 'components/ProductDropdownNewHosting';


const Hosting = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const firstLoad = useRef(true);
  const location = useLocation();
  const domainRef = useRef(null);
  const lastServerRef = useRef(null);
  const { state } = location;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pid = params.get("pid");
    const billingcycle = params.get("billingcycle");
    dispatch(setOrderParams({ pid, billingcycle }));
  }, [location.search, dispatch]);

  const currentProduct = useSelector(selectProduct);
  const { gid: currentGID, name: currentProdName } = currentProduct.current;
  const productGroup = useSelector((state) => state.hosting.products);
  const { noDomain, status: loadingStatus, statusFreeDomain, freeDomainExtensions } = useSelector(
    (state) => state.hosting
  );
  const { duplicateStatus, promoCode, productsList } = useSelector(
    (state) => state.cart
  );
  const dataClient = useSelector((state) => state.auth.data_login);

  const [termin, setTermin] = useState("");
  const [priceByTermin, setPriceByTermin] = useState(0);
  const [pricePromoLite1, setPricePromoLite1] = useState(0);
  const [pricePromoLite2, setPricePromoLite2] = useState(0);
  const [pricePromoProStarter, setPricePromoProStarter] = useState(0);
  const [server, setServer] = useState(0);
  const [hostingName, setHostingName] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [domainMethod, setDomainMethod] = useState("register");
  const [showBackup, setShowBackup] = useState(false);

  const [showPromo, setShowPromo] = useState(false);
  const [showPaymentGateway, setShowPaymentGateway] = useState(false);
  const [paymentGateway, setPaymentGateway] = useState(false);
  const [checked, setChecked] = useState(0);
  const [prodsValue, setProdsValue] = useState(null);
  const [isPromoApplied, setIsPromoApplied] = useState(false);
  const [registrationType, setRegistrationType] = useState("single");
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentName, setCurrentName] = useState(null);
  const [showDomainSections, setShowDomainSections] = useState(true); // DISABLED - always show
  // const velocityProduct = useSelector((state) => state.cart.velocityProduct);
  const {
    total,
    productsList: cartItems
  } = useSelector((state) => state.cart);

  const [extOption, setExtOption] = useState([]);
  const [hostingTrialStatus, setHostingTrialStatus] = useState(null);

  const [hostingProduct, setHostingProduct] = useReducer(hostingReducer, {
    pid: +query.pid || 1125,
    price: {},
    productDetails: null,
    productPanel: null,
    promo: null,
  });

  // Check Hosting UMKM status
  const checkHostingTrial = async (email) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API}order/apis/checkHostingTrial.php?email=${encodeURIComponent(email)}`);
      const data = await response.json();

      if (data.result === 'success') {
        setHostingTrialStatus(data);
      }
    } catch (error) {
      console.error('Error checking Hosting UMKM:', error);
    }
  };

  // Check Hosting UMKM when user is logged in and PID is 1115
  useEffect(() => {
    if (dataClient?.client?.email && hostingProduct.pid === 1115) {
      checkHostingTrial(dataClient.client.email);
    }
  }, [dataClient?.client?.email, hostingProduct.pid]);

  // Auto-remove PID 1115 from cart if user has already ordered it
  useEffect(() => {
    if (hostingTrialStatus?.hasTrial && cartItems.length > 0) {
      const pid1115Item = cartItems.find(item => item.pid === 1115);
      if (pid1115Item) {
        // Remove PID 1115 from cart
        dispatch(removeCartItem(1115));
        notifyError("Hosting UMKM telah dihapus dari keranjang karena Anda sudah pernah memesannya sebelumnya.");
      }
    }
  }, [hostingTrialStatus, cartItems, dispatch]);

  const methodActiveProps = {
    domainMethod,
    isVisible,
    setIsVisible,
    setDomainMethod,
    registrationType,
    setRegistrationType,
    // onToggleDomainSections: handleToggleDomainSections, // DISABLED
  };

  // Function to handle domain sections toggle
  const handleToggleDomainSections = (shouldShow) => {
    setShowDomainSections(shouldShow);

    // If showing sections, focus on the domain input after a short delay
    if (shouldShow) {
      setTimeout(() => {
        const domainInput = document.getElementById("searchDomain");
        if (domainInput) {
          domainInput.focus();
          domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  };

  // Listen for showDomainSections event from ModalHostingNoDomain
  useEffect(() => {
    const handleShowDomainSections = () => {
      setShowDomainSections(true);

      // Focus on domain input after showing sections
      setTimeout(() => {
        const domainInput = document.getElementById("searchDomain");
        if (domainInput) {
          domainInput.focus();
          domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 300); // Longer delay to ensure DOM is fully updated
    };

    window.addEventListener('showDomainSections', handleShowDomainSections);

    return () => {
      window.removeEventListener('showDomainSections', handleShowDomainSections);
    };
  }, []);

  const methodActivePropsWithToggle = {
    ...methodActiveProps,
    onToggleDomainSections: handleToggleDomainSections,
  };

  const checkPaymentGateway = () => {
    setPaymentGateway(!paymentGateway);
  };

  useEffect(() => {
    if (currentGID !== 0) {
      setServer(currentGID);
    }
  }, [currentGID]);

  useEffect(() => {
    // Gunakan query.pid jika ada untuk memastikan PID dari URL digunakan
    // TAPI, untuk GID 730 dan 731 (Velocity), jika hostingProduct.pid berbeda dari query.pid
    // dan produk tersebut ada di productGroup, itu berarti user telah mengubah produk secara manual
    // (misalnya melalui checkbox Velocity), jadi kita harus menggunakan hostingProduct.pid
    let targetPid;
    const velocityGIDs = [730, 731]; // Hanya berlaku untuk GID yang memiliki Velocity
    const isVelocityGID = velocityGIDs.includes(currentGID);

    if (query.pid && productGroup.length > 0 && isVelocityGID) {
      // Hanya untuk GID 730 dan 731: Cek apakah hostingProduct.pid ada di productGroup
      const isManualChange = productGroup.some(prod => prod.pid === hostingProduct.pid);
      if (isManualChange && hostingProduct.pid !== +query.pid) {
        // User telah mengubah produk secara manual (checkbox Velocity), gunakan hostingProduct.pid
        targetPid = hostingProduct.pid;
      } else {
        // Gunakan query.pid untuk initial load atau jika produk belum diubah
        targetPid = +query.pid;
      }
    } else {
      // Untuk GID lain atau jika tidak ada query.pid, gunakan query.pid atau hostingProduct.pid
      targetPid = query.pid ? +query.pid : hostingProduct.pid;
    }

    if (query.promocode) {
      dispatch(
        getProductPromo({
          pid: targetPid,
          billingcycle: query.billingcycle,
          promocode: query.promocode,
        })
      );
    } else if (!promoCode.queryCode) {
      dispatch(getProdsByPID(targetPid));
    }
  }, [dispatch, hostingProduct.pid, query.billingcycle, query.pid, query.promocode, promoCode.queryCode, productGroup, currentGID]);

  useEffect(() => {
    if (query.billingcycle) {
      setTermin(query.billingcycle);
    } else {
      setTermin("annually");
    }
  }, [query.billingcycle]);

  // Show domain sections by default, but hide if billing cycle >= 1 year - DISABLED
  // useEffect(() => {
  //   const longTermCycles = ["annually", "biennially", "triennially"];
  //   if (longTermCycles.includes(termin)) {
  //     setShowDomainSections(true); // Selalu tampilkan defaultnya
  //   } else {
  //     setShowDomainSections(true);
  //   }
  // }, [termin]);

  const getProductsByGID = useCallback(() => {
    if (currentGID && firstLoad.current) {
      if (query.promocode) {
        if (dataClient && dataClient.client.id) {
          dispatch(
            getProductsPromo({
              gid: currentGID,
              pid: query.pid,
              billingcycle: query.billingcycle,
              promocode: query.promocode,
              userid: dataClient.client.id,
            })
          );
        } else {
          dispatch(
            getProductsPromo({
              gid: currentGID,
              pid: query.pid,
              billingcycle: query.billingcycle,
              promocode: query.promocode,
            })
          );
        }
      } else if (promoCode.queryCode) {
        return;
      } else {
        dispatch(getProducts({ gid: currentGID, activePid: query.pid }));
      }
      firstLoad.current = false;
    }
  }, [currentGID, dataClient, dispatch, promoCode.queryCode, query.billingcycle, query.pid, query.promocode]);

  useEffect(() => {
    if (!firstLoad.current) {
      return;
    }
    getProductsByGID();
  }, [getProductsByGID]);

  useEffect(() => {
    if (productGroup.length > 0 && hostingProduct.pid) {
      // Hanya berlaku untuk GID 730 dan 731 (Velocity)
      const velocityGIDs = [730, 731];
      const isVelocityGID = velocityGIDs.includes(currentGID);

      // Untuk GID 730 dan 731: Cek apakah hostingProduct.pid ada di productGroup
      // (berarti user telah mengubah produk secara manual melalui checkbox Velocity)
      const isManualChange = isVelocityGID && productGroup.some(prod => prod.pid === hostingProduct.pid);

      // Jika user telah mengubah produk secara manual (misalnya melalui checkbox Velocity),
      // prioritaskan hostingProduct.pid daripada query.pid
      let targetPid;
      if (isManualChange && query.pid && hostingProduct.pid !== +query.pid) {
        // User telah mengubah produk secara manual, gunakan hostingProduct.pid
        targetPid = hostingProduct.pid;
      } else {
        // Gunakan query.pid untuk initial load atau jika produk belum diubah
        targetPid = query.pid ? +query.pid : hostingProduct.pid;
      }

      const foundProduct = productGroup.find(prods => prods.pid === targetPid);

      // Jika tidak ditemukan dengan targetPid, coba dengan hostingProduct.pid
      const productToUse = foundProduct || productGroup.find(prods => prods.pid === hostingProduct.pid);

      if (productToUse && !isUpdating) {
        // Jika user telah mengubah produk secara manual (hanya untuk GID 730/731), jangan override dengan query.pid
        // Untuk GID lain, tetap prioritaskan query.pid untuk initial load
        if (query.pid && !isManualChange && productToUse.pid !== +query.pid) {
          return; // Jangan update jika PID tidak sesuai dengan query (hanya untuk initial load)
        }

        setIsUpdating(true);

        setHostingProduct({
          type: "SET_PRODUCT_PRICE",
          payload: productToUse.pricing.IDR,
        });

        setHostingProduct({
          type: "SET_PRODUCT_DETAIL",
          payload: {
            pid: productToUse.pid,
            gid: productToUse.gid,
            name: productToUse.name,
            type: productToUse.type,
            billingcycle: termin,
            price: productToUse.pricing.IDR[termin] || 0,
          },
        });

        if (productToUse.promo) {
          setHostingProduct({
            type: "SET_PROMO",
            payload: {
              pid: productToUse.pid,
              realprice: productToUse.realprice,
              appliesto: productToUse.promo.appliesto,
              description: productToUse.promo.description,
              price: productToUse.promo.price,
              type: productToUse.promo.type,
              promocode: productToUse.promocode,
            },
          });
        }

        setHostingName(productToUse.name);
        setIsUpdating(false);
      }
    }
  }, [hostingProduct.pid, productGroup, termin, isUpdating, query.pid, currentGID]);

  useEffect(() => {
    // Hindari update state jika nilai tidak berubah
    const getNewPrice = () => {
      switch (termin) {
        case "triennially":
          return hostingProduct.price.triennially || 0;
        case "biennially":
          return hostingProduct.price.biennially || 0;
        case "annually":
          return hostingProduct.price.annually || 0;
        case "quarterly":
          return hostingProduct.price.quarterly || 0;
        case "semiannually":
          return hostingProduct.price.semiannually || 0;
        case "monthly":
          return hostingProduct.price.monthly || 0;
        default:
          return 0;
      }
    };

    const newPrice = getNewPrice();
    if (newPrice !== priceByTermin) {
      setPriceByTermin(newPrice);
    }
  }, [
    termin,
    hostingProduct.price.annually,
    hostingProduct.price.biennially,
    hostingProduct.price.monthly,
    hostingProduct.price.quarterly,
    hostingProduct.price.semiannually,
    hostingProduct.price.triennially,
    priceByTermin
  ]);

  useEffect(() => {
    if (currentProduct.status === "idle" && hostingProduct.productDetails && !isUpdating) {
      const newPrice =
        hostingProduct.pid === 1007 && pricePromoLite1 !== 0 ? +pricePromoLite1 :
          hostingProduct.pid === 1008 && pricePromoLite2 !== 0 ? +pricePromoLite2 :
            (hostingProduct.pid === 1010 || hostingProduct.pid === 1031 ||
              hostingProduct.pid === 1045 || hostingProduct.pid === 1059) &&
              pricePromoProStarter !== 0 ? +pricePromoProStarter : +priceByTermin;

      const currentPrice = hostingProduct.productDetails.price;

      if (currentPrice !== newPrice || hostingProduct.productDetails.billingcycle !== termin) {
        setIsUpdating(true);
        setHostingProduct({
          type: "SET_PRODUCT_DETAIL",
          payload: {
            ...hostingProduct.productDetails,
            billingcycle: termin,
            price: newPrice,
          },
        });
        setIsUpdating(false);
      }
    }
  }, [
    currentProduct.status,
    hostingProduct.pid,
    hostingProduct.productDetails,
    priceByTermin,
    pricePromoLite1,
    pricePromoLite2,
    pricePromoProStarter,
    termin,
    isUpdating
  ]);

  useEffect(() => {
    if (currentGID === 692) {
      const cpanelProds = productGroup.filter((item) =>
        item.name.includes("cPanel")
      );

      const directAdminProds = productGroup.filter((item) =>
        item.name.includes("DirectAdmin")
      );

      setHostingProduct({
        type: "SET_PANEL_VHC_PRODS",
        payload: [{
          cpanel: cpanelProds
        }, {
          directAdmin: directAdminProds
        }],
      });
    } else if (
      currentGID === 709 ||
      currentGID === 710 ||
      currentGID === 711 ||
      currentGID === 713 ||
      currentGID === 714 ||
      currentGID === 715 ||
      currentGID === 716 ||
      currentGID === 717 ||
      currentGID === 718
    ) {
      setHostingProduct({
        type: "SET_PANEL_VHC_PRODS",
        payload: [{
          directAdmin: productGroup
        }],
      });
    }
  }, [currentGID, productGroup]);

  const terminHandle = (e) => {
    const newTermin = e.target.value;

    // Update price first
    const newPrice = hostingProduct.price[newTermin] || 0;
    setPriceByTermin(newPrice);

    if (promoCode.queryCode) {
      if (dataClient && dataClient.client.id) {
        dispatch(
          getProductsPromo({
            gid: currentGID,
            pid: hostingProduct.productDetails.pid,
            billingcycle: newTermin,
            promocode: promoCode.queryCode,
            userid: dataClient.client.id,
          })
        );
      } else {
        dispatch(
          getProductsPromo({
            gid: currentGID,
            pid: hostingProduct.productDetails.pid,
            billingcycle: newTermin,
            promocode: promoCode.queryCode,
          })
        );
      }
    } else {
      // Update product details dengan harga baru
      setHostingProduct({
        type: "SET_PRODUCT_DETAIL",
        payload: {
          ...hostingProduct.productDetails,
          billingcycle: newTermin,
          price: hostingProduct.pid === 1007 && pricePromoLite1 !== 0
            ? +pricePromoLite1
            : hostingProduct.pid === 1008 && pricePromoLite2 !== 0
              ? +pricePromoLite2
              : (hostingProduct.pid === 1010 ||
                hostingProduct.pid === 1031 ||
                hostingProduct.pid === 1045 ||
                hostingProduct.pid === 1059) &&
                pricePromoProStarter !== 0
                ? +pricePromoProStarter
                : +newPrice, // Gunakan harga baru
        },
      });

      // Refresh product data
      dispatch(getProdsByPID(hostingProduct.productDetails.pid));
    }

    setTermin(newTermin);
  };

  const addToCartHandler = () => {
    // Check if user has already ordered Hosting UMKM (PID 1115)
    if (hostingProduct.pid === 1115 && hostingTrialStatus?.hasTrial) {
      notifyError("Maaf! Anda sudah pernah memesan Hosting ini sebelumnya. Setiap user hanya dapat memesan Hosting UMKM sekali saja.");
      return;
    }

    if (currentProduct.status === "idle" && hostingProduct.productDetails) {
      // const updatedProductDetails = {
      //   ...hostingProduct.productDetails,
      //   billingcycle: termin
      // };

      // console.log("updatedProductDetails", updatedProductDetails);
      // console.log("velocityProduct", velocityProduct);
      // if (velocityProduct) {
      //   dispatch(addToCart(velocityProduct));
      // } else {
      //   dispatch(addToCart(updatedProductDetails));
      // }

      const selectedBillingCycle = termin;
      dispatch(addToCart({
        ...hostingProduct.productDetails,
        billingcycle: selectedBillingCycle,
      }));

      if (paymentGateway && showPaymentGateway &&
        termin !== "monthly" && termin !== "quarterly" &&
        termin !== "semiannually") {
        dispatch(addPaymentGateway({ paymentGateway: paymentGateway }));
      }

      if (hostingProduct.promo &&
        hostingProduct.productDetails.pid === hostingProduct.promo.pid) {
        dispatch(addPromo(hostingProduct.promo));
      }

      if (!duplicateStatus) {
        notifySuccess("Produk berhasil masuk keranjang!");
      }
    }
    return;
  };

  const handlerMigrasi = () => {
    const { pid, billingcycle } = query;

    if (pid && !billingcycle) {
      window.location.href = `/orderv10/migrasihosting?pid=${pid}`;
    } else if (pid && billingcycle) {
      window.location.href = `/orderv10/migrasihosting?pid=${pid}&billingcycle=${billingcycle}`;
    } else {
      window.location.href = `/orderv10/migrasihosting`;
    }
  };

  const handlerOrderHosting = () => {
    const { pid, billingcycle } = query;

    if (pid && !billingcycle) {
      window.location.href = `/orderv10/orderhosting?pid=${pid}`;
    } else if (pid && billingcycle) {
      window.location.href = `/orderv10/orderhosting?pid=${pid}&billingcycle=${billingcycle}`;
    } else {
      window.location.href = `/orderv10/orderhosting`;
    }
  };

  useEffect(() => {
    if (
      currentProduct.status === "idle" &&
      hostingProduct.productDetails &&
      productsList.length > 0
    ) {
      let modifiedProductDetails = { ...hostingProduct.productDetails };

      if (currentName === "sgp") {
        modifiedProductDetails.priceWithAddon = null;
      }

      if (!showPaymentGateway && !paymentGateway) {
        dispatch(addPaymentGateway({ paymentGateway: "" }));
      } else if (!showPaymentGateway && paymentGateway) {
        dispatch(addPaymentGateway({ paymentGateway: "" }));
      } else if (showPaymentGateway && !paymentGateway) {
        dispatch(addPaymentGateway({ paymentGateway: "" }));
      } else {
        dispatch(addPaymentGateway({ paymentGateway: true }));
      }

      dispatch(changeProductFromCart(modifiedProductDetails));
    }
  }, [currentProduct.status, dispatch, hostingProduct.productDetails, paymentGateway, productsList.length, showPaymentGateway]);

  useEffect(() => {
    if (hostingProduct.productDetails) {
      const backupPidList = [
        529, 527, 533, 531, 537, 535, 541, 539, 1020, 1021, 1022, 1023, 1024,
        1025, 1026, 1027, 1028, 1029, 1030, 1038, 1039, 1040, 1041, 1042, 1043,
        1044, 1052, 1053, 1054, 1055, 1056, 1057, 1066, 1067, 1068, 1069, 1070, 1071, 1072,
      ];
      setShowBackup(backupPidList.includes(hostingProduct.productDetails?.pid));
    }
  }, [hostingProduct.productDetails]);



  useEffect(() => {
    if (
      currentGID === 711 ||
      currentGID === 714 ||
      currentGID === 716 ||
      currentGID === 718
    ) {
      setShowPaymentGateway(true);
    } else {
      setShowPaymentGateway(false);
    }
  }, [hostingProduct.productDetails, currentGID, termin]);

  useEffect(() => {
    const includePID = ["1003", "1004", "1005"];
    const startDate = new Date("2024-10-01T07:00:00+07:00");
    const endDate = new Date("2024-12-31T07:00:00+07:00");
    const currentDate = new Date();

    const isWithinPromoPeriod =
      currentDate >= startDate && currentDate < endDate;

    const shouldApplyPromo =
      includePID.includes(query.pid) &&
      location.pathname !== "/paymentmethod" &&
      location.pathname !== "/orderesummary" &&
      !query.promocode &&
      isWithinPromoPeriod;

    if (shouldApplyPromo) {
      dispatch(setQueryPromo("SAVEWITHFLEX"));
      dispatch(
        getProductsPromo({
          gid: currentGID,
          pid: query.pid,
          billingcycle: query.billingcycle,
          promocode: "SAVEWITHFLEX",
        })
      );
    } else if (query.promocode) {
      dispatch(setQueryPromo(query.promocode));
    } else {
      dispatch(setQueryPromo(null));
      dispatch(removePromoCode());
    }
  }, [currentGID, dispatch, location.pathname, query.billingcycle, query.pid, query.promocode]);

  useEffect(() => {
    if (
      currentGID === 681 ||
      query.pid === 392 ||
      query.pid === 397 ||
      query.pid === 402
    ) {
      window.location.href = "/orderv10/orderhosting?pid=1006";
    }
  }, [currentGID, query.pid]);

  useEffect(() => {
    if (noDomain) {
      domainRef.current.scrollIntoView({
        behavior: "smooth",
        position: "center",
      });
      dispatch(isNoDomain(false));
    }
  }, [dispatch, noDomain]);

  // const getDiscountPercentage = (pid, billingcycle) => {
  //   const discounts = {
  //     annually: {
  //       526: 30,
  //       528: 30,
  //       530: 10,
  //       532: 10,
  //       534: 20,
  //       536: 20,
  //       976: 20,
  //       538: 40,
  //       540: 40,
  //       975: 40,
  //       1006: 10,
  //       1009: 20,
  //     },
  //     monthly: {
  //       1007: 20,
  //       1008: 30,
  //     },
  //     quarterly: {
  //       1007: 20,
  //       1008: 30,
  //     },
  //     semiannually: {
  //       1007: 20,
  //       1008: 30,
  //     },
  //   };
  //   return discounts[billingcycle]?.[pid] || null;
  // };

  // const getOriginalPrice = (pid, billingcycle) => {
  //   const prices = {
  //     annually: {
  //       528: "Rp252.000",
  //       526: "Rp762.000",
  //       530: "Rp936.000",
  //       532: "Rp498.000",
  //       534: "Rp1.428.000",
  //       976: "Rp1.428.000",
  //       536: "Rp972.000",
  //       540: "Rp2.172.000",
  //       538: "Rp2.784.000",
  //       975: "Rp2.784.000",
  //       1006: "Rp336.000",
  //       1009: "Rp3.600.000",
  //     },
  //     monthly: {
  //       1007: "Rp80.000",
  //       1008: "Rp170.000",
  //     },
  //     quarterly: {
  //       1007: "Rp240.000",
  //       1008: "Rp510.000",
  //     },
  //     semiannually: {
  //       1007: "Rp480.000",
  //       1008: "Rp1.020.000",
  //     },
  //   };
  //   return prices[billingcycle]?.[pid] || null;
  // };

  const hostingProductPanelInit = [
    { id: 1, value: "Enterprise 1" },
    { id: 2, value: "Enterprise 2" },
    { id: 3, value: "Enterprise 3" },
  ];

  const panelOptions = [
    { id: 712, name: "cPanel", icon: cpanelIcon },
    { id: 723, name: "DirectAdmin", icon: directAdminIcon },
  ];

  const panelHandler = (e) => {
    const selectedPanel = parseInt(e.target.value);
    if (selectedPanel !== checked) {
      setChecked(selectedPanel);

      let pid;
      if (currentGID === 723) {
        if (currentProdName === "Cloud Hosting Enterprise 1 (DirectAdmin)" && selectedPanel === 712) {
          pid = 1017;
        } else if (currentProdName === "Cloud Hosting Enterprise 2 (DirectAdmin)" && selectedPanel === 712) {
          pid = 1018;
        } else if (currentProdName === "Cloud Hosting Enterprise 3 (DirectAdmin)" && selectedPanel === 712) {
          pid = 1019;
        }
      } else if (currentGID === 712) {
        if (currentProdName === "Cloud Hosting Enterprise 1" && selectedPanel === 723) {
          pid = 1107;
        } else if (currentProdName === "Cloud Hosting Enterprise 2" && selectedPanel === 723) {
          pid = 1108;
        } else if (currentProdName === "Cloud Hosting Enterprise 3" && selectedPanel === 723) {
          pid = 1109;
        }
      }

      if (pid) {
        window.location.href = `/orderv10/orderhosting?pid=${pid}&billingcycle=${termin}`;
      }
    }
  };

  useEffect(() => {
    if (prodsValue === null || prodsValue === "") {
      if (typeof currentProdName === 'string') {
        const newValue = currentProdName.includes("Enterprise 1")
          ? "Enterprise 1"
          : currentProdName.includes("Enterprise 2")
            ? "Enterprise 2"
            : currentProdName.includes("Enterprise 3")
              ? "Enterprise 3"
              : null;

        if (newValue !== prodsValue) {
          setProdsValue(newValue);
        }
      }
    }
  }, [currentProdName, prodsValue]);

  const hostingProductHandler = (e) => {
    const selectedProductValue = e.target.value;
    if (selectedProductValue !== prodsValue) {
      setProdsValue(selectedProductValue);

      let selectedPID;
      if (currentGID === 712) {
        if (selectedProductValue === "Enterprise 1") {
          selectedPID = 1017;
        } else if (selectedProductValue === "Enterprise 2") {
          selectedPID = 1018;
        } else if (selectedProductValue === "Enterprise 3") {
          selectedPID = 1019;
        }
      } else if (currentGID === 723) {
        if (selectedProductValue === "Enterprise 1") {
          selectedPID = 1107;
        } else if (selectedProductValue === "Enterprise 2") {
          selectedPID = 1108;
        } else if (selectedProductValue === "Enterprise 3") {
          selectedPID = 1109;
        }
      }

      if (selectedPID && selectedPID !== hostingProduct.pid) {
        setHostingProduct({
          type: 'SET_CURRENT_PID',
          payload: selectedPID,
        });
      }
    }
  };

  useEffect(() => {
    if (currentGID === 712) {
      setChecked(712);
    } else if (currentGID === 723) {
      setChecked(723);
    }
  }, [currentGID]);

  useEffect(() => {
    if ((query.pid === '1117' && query.billingcycle === 'annually' && cartItems) || state?.fromSuccessDomainRegister) {
      try {
        // Check promo period
        const promoEndDate = new Date('2025-04-04T23:59:00+07:00');
        const currentDate = new Date();
        const isWithinPromoPeriod = currentDate <= promoEndDate;

        if (!isWithinPromoPeriod) {
          setIsPromoApplied(false);
          dispatch(removePromoCode());
          return;
        }

        const hasDomainIdOrCom = cartItems?.some(item => {
          const tld = getOnlyTLD(item.domain);
          return tld === '.id' || tld === '.com';
        }) || false;

        const hasValidBillingCycle = cartItems?.some(item => {
          return item.billingcycle === 'annually';
        }) || false;

        const data = {
          "status": "valid",
          "description": "",
          "price": "100.00",
          "type": "Percentage",
          "appliesto": "1117",
          "message": "The promo is valid."
        }

        if (hasDomainIdOrCom && hasValidBillingCycle) {
          if (location.pathname === "/migrasihosting") {
            dispatch(setPromoCode({ promo: "MIGRASIGRATISHOSTING", data: data }));
          } else if (location.pathname === "/orderhosting") {
            dispatch(setPromoCode({ promo: "BELIDOMAINGRATISHOSTING", data: data }));
          }
          setIsPromoApplied(true);
        } else {
          setIsPromoApplied(false);
          dispatch(removePromoCode());
        }
      } catch (error) {
        console.error('Error handling promo:', error);
        setIsPromoApplied(false);
        dispatch(removePromoCode());
      }
    } else {
      // Reset promo state when conditions are not met
      setIsPromoApplied(false);
      dispatch(removePromoCode());
    }
  }, [cartItems, dispatch, query.pid, query.billingcycle, location.pathname, state?.fromSuccessDomainRegister]);

  useEffect(() => {
    if (state?.fromSuccessDomainRegister) {
      if (hostingProduct.productDetails) {
        dispatch(addToCart({
          name: hostingProduct.productDetails.name,
          price: 0,
          status: hostingProduct.productDetails.status,
          pid: hostingProduct.productDetails.pid,
          billingcycle: hostingProduct.productDetails.billingcycle,
        }));
      }

      const domainDetails = state.domainDetails;
      if (domainDetails) {
        dispatch(addDomainToCart({
          name: domainDetails.domain,
          price: domainDetails.isFreeDomain ? 0 : domainDetails.price,
          status: domainDetails.status,
          domain: domainDetails.domain,
          duration: domainDetails.duration,
          priceRenew: domainDetails.priceRenew,
          type: "register",
          isWhois: domainDetails.isFreeWhois === true ? false : domainDetails.state_whois,
          freeWhois: domainDetails.isFreeWhois,
          domainForwarder: domainDetails.bundleDomain ? domainDetails.domainForwarder : null,
          activateLater: domainDetails.bundleDomain ? domainDetails.activateLater : null,
          isDonut: domainDetails.infoDonuts,
        }));
      }

      const whoisDetails = state.whoisDetails;
      if (whoisDetails && whoisDetails.length > 0) {
        whoisDetails.forEach(whois => {
          dispatch(addWhoisToCart(whois));
        });
      }
    }
  }, [state, hostingProduct.productDetails, dispatch]);

  useEffect(() => {
    if (hostingProduct.productDetails && hostingProduct.productDetails.pid !== 1115) {
      setShowPromo(true);
      if (hostingProduct.productDetails.pid === 1007) {
        setPricePromoLite1(0);
      } else if (hostingProduct.productDetails.pid === 1008) {
        setPricePromoLite2(0);
      } else if ([1010, 1031, 1045, 1059].includes(hostingProduct.productDetails.pid)) {
        setPricePromoProStarter(0);
      }
    } else {
      setShowPromo(false);
      setPricePromoLite1(0);
      setPricePromoLite2(0);
      setPricePromoProStarter(0);
    }
  }, [hostingProduct.productDetails]);

  // Handler untuk perubahan server - update produk sesuai server baru
  const handleServerChange = useCallback((newServerId) => {
    dispatch(getProducts({ gid: newServerId, activePid: query.pid }));
  }, [dispatch, query.pid]);

  // Update produk ketika server berubah untuk Cloud WP (GID 711, 714, 716, 718)
  useEffect(() => {
    const cloudWpGIDs = [711, 714, 716, 718];
    if (!cloudWpGIDs.includes(server) || !productGroup.length) {
      return;
    }

    // Cek apakah server benar-benar berubah
    if (lastServerRef.current === server && hostingProduct.productDetails?.name) {
      // Cek apakah produk sudah sesuai dengan server
      const productName = hostingProduct.productDetails.name;
      const hasServerName = productName && /\([^)]+\)/.test(productName);

      // Untuk GID 711, produk tidak memiliki server name
      // Untuk GID lainnya, produk memiliki server name
      if (server === 711) {
        // GID 711: produk harus tidak memiliki server name
        if (!hasServerName) {
          return; // Produk sudah sesuai, tidak perlu update
        }
      } else {
        // GID lainnya: produk harus memiliki server name yang sesuai
        const serverNameMap = {
          714: 'SouthJKT-2',
          716: 'WestJavaBDG-1',
          718: 'Singapura',
        };
        const serverName = serverNameMap[server];
        if (serverName && productName.includes(`(${serverName})`)) {
          return; // Produk sudah sesuai, tidak perlu update
        }
      }
    }

    // Mapping GID ke server name
    const serverNameMap = {
      711: 'SouthJKT-1',
      714: 'SouthJKT-2',
      716: 'WestJavaBDG-1',
      718: 'Singapura',
    };

    const serverName = serverNameMap[server];
    if (!serverName) return;

    // Untuk GID 711 (SouthJKT-1), produk tidak memiliki server name
    // Untuk GID lainnya (714, 716, 718), produk memiliki server name
    const hasServerName = server !== 711;

    // Gunakan nama produk dari hostingProduct atau currentProdName
    const currentProductName = hostingProduct.productDetails?.name || currentProdName || '';

    // Extract nama dasar produk (tanpa name server dan tanpa "+ Backup Harian")
    const baseName = currentProductName
      .replace(/\s*\([^)]+\)\s*/g, '') // Hapus name server dalam kurung
      .replace(/\s*\+\s*Backup\s*Harian\s*/gi, '') // Hapus "+ Backup Harian"
      .trim();

    // Cek apakah produk saat ini memiliki backup harian
    const hasBackup = currentProductName.includes("+ Backup Harian");

    // Cari produk yang sesuai dengan nama dasar + server name (jika ada) + backup status
    const matchingProduct = productGroup.find(prod => {
      const prodName = prod.name.trim();
      // Extract server name dari produk (jika ada)
      const prodNameServerMatch = prodName.match(/\(([^)]+)\)/);
      const prodNameServer = prodNameServerMatch ? prodNameServerMatch[1] : null;

      // Cek apakah nama dasar sama (tanpa name server dan backup)
      const prodBaseName = prodName
        .replace(/\s*\([^)]+\)\s*/g, '')
        .replace(/\s*\+\s*Backup\s*Harian\s*/gi, '')
        .trim();

      // Cek backup status
      const prodHasBackup = prodName.includes("+ Backup Harian");

      // Untuk GID 711: produk tidak memiliki server name, jadi cari produk tanpa server name
      // Untuk GID lainnya: produk memiliki server name, jadi cari produk dengan server name yang sesuai
      if (hasServerName) {
        // Harus match server name
        return prodBaseName === baseName &&
               prodNameServer === serverName &&
               prodHasBackup === hasBackup;
      } else {
        // GID 711: tidak perlu match server name (produk tidak memiliki server name)
        return prodBaseName === baseName &&
               prodNameServer === null &&
               prodHasBackup === hasBackup;
      }
    });

    // Jika ditemukan produk yang sesuai dan berbeda dengan PID saat ini
    if (matchingProduct && matchingProduct.pid !== hostingProduct.pid) {
      lastServerRef.current = server;
      setHostingProduct({
        type: 'SET_CURRENT_PID',
        payload: matchingProduct.pid,
      });
      dispatch(getProdsByPID(matchingProduct.pid));
      return;
    }

    // Jika tidak ditemukan dengan backup status yang sama, cari tanpa mempertimbangkan backup
    const fallbackProduct = productGroup.find(prod => {
      const prodName = prod.name.trim();
      const prodNameServerMatch = prodName.match(/\(([^)]+)\)/);
      const prodNameServer = prodNameServerMatch ? prodNameServerMatch[1] : null;
      const prodBaseName = prodName
        .replace(/\s*\([^)]+\)\s*/g, '')
        .replace(/\s*\+\s*Backup\s*Harian\s*/gi, '')
        .trim();

      if (hasServerName) {
        return prodBaseName === baseName && prodNameServer === serverName;
      } else {
        return prodBaseName === baseName && prodNameServer === null;
      }
    });

    if (fallbackProduct && fallbackProduct.pid !== hostingProduct.pid) {
      lastServerRef.current = server;
      setHostingProduct({
        type: 'SET_CURRENT_PID',
        payload: fallbackProduct.pid,
      });
      dispatch(getProdsByPID(fallbackProduct.pid));
      return;
    }

    // Jika tidak ditemukan produk yang sesuai dengan base name,
    // pilih produk pertama dari server yang dipilih
    let firstProductFromServer;
    if (hasServerName) {
      // Untuk GID dengan server name, cari produk dengan server name
      firstProductFromServer = productGroup.find(prod => {
        const prodName = prod.name.trim();
        return prodName.includes(`(${serverName})`);
      });
    } else {
      // Untuk GID 711, cari produk tanpa server name
      firstProductFromServer = productGroup.find(prod => {
        const prodName = prod.name.trim();
        const prodNameServerMatch = prodName.match(/\(([^)]+)\)/);
        return prodNameServerMatch === null; // Tidak memiliki server name
      });
    }

    if (firstProductFromServer && firstProductFromServer.pid !== hostingProduct.pid) {
      lastServerRef.current = server;
      setHostingProduct({
        type: 'SET_CURRENT_PID',
        payload: firstProductFromServer.pid,
      });
      dispatch(getProdsByPID(firstProductFromServer.pid));
    } else if (!firstProductFromServer) {
      // Update lastServerRef meskipun tidak ada produk yang cocok
      lastServerRef.current = server;
    }
  }, [productGroup, currentProdName, server, hostingProduct.pid, hostingProduct.productDetails?.name, dispatch, setHostingProduct]);

  useEffect(() => {
    // Jika cart kosong selama 1 detik, otomatis addToCart
    let timer;
    const excludedGIDs = [729, 730, 731]; // MaxMail, Proxima, Hyper Quantum

    if (cartItems.length === 0 && hostingProduct.productDetails && !excludedGIDs.includes(currentGID)) {
      // Prevent auto-add PID 1115 if user has already ordered it
      if (hostingProduct.pid === 1115 && hostingTrialStatus?.hasTrial) {
        return;
      }

      timer = setTimeout(() => {
        dispatch(addToCart({
          ...hostingProduct.productDetails,
          billingcycle: termin
        }));
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [cartItems.length, hostingProduct.productDetails, dispatch, termin, currentGID, hostingProduct.pid, hostingTrialStatus]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((data) => data.json())
      .then((val) => setExtOption(val));
  }, []);

  const isEligibleForFreeDomain = statusFreeDomain;

  return (
    <MainLayouts summary={false}>
      {currentGID !== 692 && (
        <ServerOptions
          server={server}
          setServer={setServer}
          currentProdName={currentProdName}
          setCurrentName={setCurrentName}
          onServerChange={handleServerChange}
          activePid={query.pid}
        />
      )}

      {(currentGID === 712 || currentGID === 723) && (
        <Card className="rounded-4 border-0 shadow-sm mb-4">
          <Card.Body>
            <Row>
              <Col xs={6} className="mb-1 mt-2">
                <h5 className="fw-bold">Produk Panel</h5>
              </Col>
              <div className="px-4">
                <label className="mb-3 small fw-semibold">
                  Pilih produk panel sesuai dengan kebutuhan anda
                </label>
                {panelOptions.map((panel) => (
                  <Col xs={12} key={panel.id} className="mb-3">
                    <div className="form-check">
                      <input
                        type="radio"
                        name="panel"
                        className="form-check-input me-3"
                        id={`panel${panel.id}`}
                        value={panel.id}
                        checked={parseInt(checked) === panel.id || (currentGID === 712 && panel.id === 712) || (currentGID === 723 && panel.id === 723)}
                        onChange={panelHandler}
                      />
                      <label htmlFor={`panel${panel.id}`} className="form-check-label">
                        <img src={panel.icon} alt={`${panel.name}.png`} />
                      </label>
                    </div>
                  </Col>
                ))}
              </div>
            </Row>
          </Card.Body>
        </Card>
      )}

      <CardWrapper
        title={
          location.pathname === "/migrasihosting"
            ? "Migrasi Hosting"
            : "Order Hosting"
        }
      >
        {/* Hosting UMKM Status Alert */}
        {hostingProduct.pid === 1115 && hostingTrialStatus && (
          <div className="row mb-3">
            <div className="col-12">
              {hostingTrialStatus.hasTrial ? (
                <div className="alert alert-warning d-flex align-items-center" role="alert">
                  <div className="me-2">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                  <div>
                    <strong>Maaf!</strong> Anda sudah pernah memesan Hosting ini sebelumnya.
                    Setiap user hanya dapat memesan Hosting UMKM sekali saja.
                  </div>
                </div>
              ) : (
                <div className="alert alert-info d-flex align-items-center" role="alert">
                  <div className="me-2">
                    <i className="fas fa-info-circle"></i>
                  </div>
                  <div>
                    <strong>Hosting UMKM!</strong> Anda dapat memesan Hosting UMKM.
                    Setiap user hanya dapat memesan sekali saja.
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="row align-items-end">
          <div className="col-12">
            {location.pathname === "/orderhosting" ? (
              <div
                className="py-3 px-3 w-100 mb-4 rounded-3 shadow-sm hosting-migration-banner"
                style={{ backgroundColor: "#FFCF9D" }}
              >
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                  <div className="h6 mb-0 text-center text-md-start">
                    Migrasi Hosting ke Qwords?
                  </div>
                  <button
                    onClick={handlerMigrasi}
                    className="mt-2 btn btn-outline-qw-primary fw-bold px-4 py-2 rounded-5"
                    style={{ minWidth: "80px" }}
                  >
                    Ya
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="py-3 px-3 w-100 mb-4 rounded-3 shadow-sm hosting-migration-banner"
                style={{ backgroundColor: "#FFCF9D" }}
              >
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                  <div className="h6 mb-0 text-center text-md-start">
                    Daftar Hosting Baru?
                  </div>
                  <button
                    onClick={handlerOrderHosting}
                    className="btn btn-outline-qw-primary fw-bold px-4 py-2 rounded-5"
                    style={{ minWidth: "80px" }}
                  >
                    Ya
                  </button>
                </div>
              </div>
            )}

            {/* <ProductDropdownNewHosting
              hostingProduct={hostingProduct}
              setHostingProduct={setHostingProduct}
              productGroup={productGroup}
              currentProduct={currentProduct}
            /> */}

            {currentProduct.status === "loading" &&
              loadingStatus === "loading" && (
                <Placeholder as="div" animation="glow">
                  <Placeholder xs={6} bg="danger" />
                </Placeholder>
              )}
            {currentProduct.status === "idle" && loadingStatus === "idle" && (
              <>
                {/* Nama Produk */}
                <div className="row">
                  <div className="col-12 mb-2">
                    <div className="fw-bold text-qw-primary h5 product-title">
                      {[729, 730, 731].includes(currentGID)
                        ? currentProdName.replace(' + Velocity', '')
                        : currentProdName
                      }
                    </div>
                  </div>
                </div>

                {/* Spesifikasi Produk */}
                {(() => {
                  const pid = hostingProduct.productDetails?.pid;
                  const productName = hostingProduct.productDetails?.name || currentProdName || '';
                  let specs = null;

                  // Tentukan tipe SSD berdasarkan GID atau nama produk
                  // MaxMail (GID 729) = Hybrid SSD
                  // Proxima (GID 730) = Ultrafast SSD
                  // Core/Hyper Quantum (GID 731) = Ultrafast SSD
                  const isMaxMail = currentGID === 729 ||
                    productName.includes('MaxMail') ||
                    productName.includes('Micro') ||
                    productName.includes('Starter') ||
                    productName.includes('Lite') ||
                    productName.includes('SOHO');
                  const isProxima = currentGID === 730 || productName.includes('Proxima');
                  const isCore = currentGID === 731 ||
                    productName.includes('Core') ||
                    productName.includes('Hyper Quantum');

                  // Tentukan tipe SSD berdasarkan GID (prioritas utama)
                  // Jika GID tidak jelas, gunakan nama produk sebagai fallback
                  let ssdType = "Hybrid SSD"; // default
                  if (currentGID === 729) {
                    ssdType = "Hybrid SSD";
                  } else if (currentGID === 730 || currentGID === 731) {
                    ssdType = "Ultrafast SSD";
                  } else if (isProxima || isCore) {
                    ssdType = "Ultrafast SSD";
                  } else if (isMaxMail) {
                    ssdType = "Hybrid SSD";
                  }

                  // Tentukan spesifikasi berdasarkan PID
                  if ([1128, 1129].includes(pid)) {
                    specs = {
                      siteHosted: "1",
                      diskSpace: `5 GB ${ssdType}`,
                      emailAccount: "10",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1130, 1131].includes(pid)) {
                    specs = {
                      siteHosted: "2",
                      diskSpace: `10 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1132, 1133].includes(pid)) {
                    specs = {
                      siteHosted: "5",
                      diskSpace: `25 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1134, 1135].includes(pid)) {
                    specs = {
                      siteHosted: "0",
                      diskSpace: `50 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1136, 1137].includes(pid)) {
                    specs = {
                      siteHosted: "10",
                      diskSpace: `100 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1138, 1139].includes(pid)) {
                    specs = {
                      siteHosted: "25",
                      diskSpace: `200 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1140, 1141].includes(pid)) {
                    specs = {
                      siteHosted: "50",
                      diskSpace: `300 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  } else if ([1142, 1143].includes(pid)) {
                    specs = {
                      siteHosted: "100",
                      diskSpace: `400 GB ${ssdType}`,
                      emailAccount: "Unlimited",
                      controlPanel: "Panel Hosting"
                    };
                  }

                  // Tampilkan spesifikasi jika ada
                  if (specs) {
                    return (
                      <div className="row hosting-specs">
                        <div className="col-12 mb-3">
                          {/* Baris Pertama */}
                          <div className="row mb-2">

                            <div className="col-6">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                                <span className="text-muted small">
                                  <strong>Disk Space:</strong> {specs.diskSpace}
                                </span>
                              </div>
                            </div>

                            <div className="col-6">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                                <span className="text-muted small">
                                  <strong>Site Hosted:</strong> {specs.siteHosted}
                                </span>
                              </div>
                            </div>

                          </div>
                          {/* Baris Kedua */}
                          <div className="row">
                            <div className="col-6">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                                <span className="text-muted small">
                                  <strong>Email Account:</strong> {specs.emailAccount}
                                </span>
                              </div>
                            </div>

                            <div className="col-6">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                                <span className="text-muted small">
                                  <strong>Easy To Use Control </strong> {specs.controlPanel}
                                </span>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    );
                  }

                  return null;
                })()}

                {/* Baris Durasi - Hemat - Harga */}
                <div className="row mb-3 g-3">
                  {/* Durasi - Full width di mobile, 1/3 di desktop */}
                  <div className="col-12 col-lg-4">
                    <BillingCycleOptions
                      termin={termin}
                      terminHandle={terminHandle}
                      productsItem={hostingProduct}
                      pid={hostingProduct.pid}
                    />
                  </div>

                  {/* Container untuk Hemat dan Harga */}
                  <div className="col-12 col-lg-8">
                    <div className="row g-2 g-lg-3 align-items-center">
                      {/* Hemat */}
                      <div className="col-6 col-lg-6 d-flex justify-content-start justify-content-lg-center align-items-center">
                        {(() => {
                          // Gunakan logic yang sama dengan CheckoutTable
                          const actualPrice = priceByTermin;
                          const pid = hostingProduct.productDetails?.pid;

                          // Untuk PID 1124-1143, gunakan monthlyPrice dari productGroup
                          const monthlyPrice = (pid >= 1124 && pid <= 1143)
                            ? hostingProduct.price?.monthly
                            : null;

                          const { hematAmount } = calculateHemat(
                            pid,
                            termin,
                            actualPrice,
                            monthlyPrice
                          );

                          let finalHemat = hematAmount;

                          // Jika tidak ada hemat dari calculateHemat, coba fallback
                          if (finalHemat <= 0) {
                            const { hematAmount: fallbackHemat } = calculateHematFallback(
                              pid,
                              termin,
                              actualPrice
                            );
                            finalHemat = fallbackHemat;
                          }

                          return finalHemat > 0 ? (
                            <span className="badge-hemat-hosting">
                              Hemat<br />Rp{finalHemat.toLocaleString("id-ID")}
                            </span>
                          ) : null;
                        })()}
                      </div>

                      {/* Harga */}
                      <div className="col-6 col-lg-6 d-flex flex-column align-items-end justify-content-center">
                        <label htmlFor="pricePop" className="label-price-hosting mb-1">
                          Harga:
                        </label>
                        <div className="price-container-hosting">
                          {(() => {
                            // Gunakan logic yang sama dengan CheckoutTable untuk harga coret
                            const actualPrice = priceByTermin;
                            const pid = hostingProduct.productDetails?.pid;

                            // Untuk PID 1124-1143, gunakan monthlyPrice dari productGroup
                            const monthlyPrice = (pid >= 1124 && pid <= 1143)
                              ? hostingProduct.price?.monthly
                              : null;

                            const { originalPrice } = calculateHemat(
                              pid,
                              termin,
                              actualPrice,
                              monthlyPrice
                            );

                            let finalOriginalPrice = originalPrice;

                            // Jika tidak ada dari calculateHemat, coba fallback
                            if (!finalOriginalPrice) {
                              const { originalPrice: fallbackOriginal } = calculateHematFallback(
                                pid,
                                termin,
                                actualPrice
                              );
                              finalOriginalPrice = fallbackOriginal;
                            }

                            // Tampilkan harga coret jika ada dan berbeda dengan harga aktual
                            if (finalOriginalPrice && finalOriginalPrice > actualPrice) {
                              return (
                                <s className="price-original-hosting">
                                  {formatIDR(finalOriginalPrice)}
                                </s>
                              );
                            }
                            // Berikan placeholder transparan untuk menjaga konsistensi layout
                            return (
                              <div className="price-placeholder-hosting">
                                &nbsp;
                              </div>
                            );
                          })()}
                          <span className="price-current-hosting">
                            {formatIDR(priceByTermin ?? 0)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {(currentGID === 712 || currentGID === 723) && (
              <div className="py-4 px-3 bg-qw-soft-primary-1 rounded-3 mt-3 shadow-sm">
                <div className="col-12 mb-3">
                  <label htmlFor="productHosting" className="fw-bold mb-3">
                    Pilih Produk
                  </label>
                  <select
                    name="productHosting"
                    id="productHosting"
                    className="form-select"
                    onChange={hostingProductHandler}
                    value={prodsValue}
                  >
                    <option value="" disabled>Pilih Produk</option>
                    {hostingProductPanelInit.map((prods) => (
                      <option value={prods.value} key={prods.id} id={prods.id}>
                        {prods.value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          {currentProduct.status === "idle" &&
            hostingProduct.productDetails &&
            loadingStatus === "idle" ? (
            <>
              <div className="col-12 col-lg-12">
                {(currentGID === 706 || currentGID === 707) && (
                  <WordpressOrder
                    currentProduct={currentProduct}
                    productGroup={productGroup}
                    setHostingProduct={setHostingProduct}
                  />
                )}
                {currentGID === 692 && (
                  <VCHOrder
                    currentProduct={currentProduct}
                    hostingProduct={hostingProduct}
                    setHostingProduct={setHostingProduct}
                  />
                )}
                {currentGID === 681 && (
                  <UnlimitedHostingOrder
                    currentProduct={currentProduct}
                    hostingProduct={hostingProduct}
                    setHostingProduct={setHostingProduct}
                  />
                )}

                {[695, 699, 702, 696, 700, 703].includes(currentGID) && (
                  <HPCHOrder
                    currentProduct={currentProduct}
                    hostingProduct={hostingProduct}
                    setHostingProduct={setHostingProduct}
                  />
                )}

                {(() => {
                  // Cek apakah produk memiliki name server (seperti "SouthJKT-2")
                  // Pattern: nama produk mengandung text dalam kurung seperti "(SouthJKT-2)"
                  const hasNameServer = currentProdName && /\([^)]+\)/.test(currentProdName);

                  // Logika:
                  // - GID 711 tanpa name server -> TAMPILKAN (backup harian tersedia)
                  // - GID 716, 717, 718 dengan name server -> JANGAN tampilkan
                  // - GID lainnya (709, 710, 713, 714, 715) -> TAMPILKAN
                  const shouldShowCloudHosting =
                    (currentGID === 709 ||
                     currentGID === 710 ||
                     currentGID === 713 ||
                     currentGID === 714 ||
                     currentGID === 715) ||
                    (currentGID === 711 && !hasNameServer) ||
                    ((currentGID === 716 || currentGID === 717 || currentGID === 718) && !hasNameServer);

                  return shouldShowCloudHosting ? (
                    <CloudHosting
                      currentProduct={currentProduct}
                      hostingProduct={hostingProduct}
                      setHostingProduct={setHostingProduct}
                    />
                  ) : null;
                })()}
              </div>

            </>
          ) : (
            <Placeholder as="div" animation="glow">
              <div>
                <Placeholder xs={1} bg="danger" />
              </div>
              <div>
                <Placeholder xs={1} bg="danger" />
              </div>
              <div>
                <Placeholder xs={1} bg="danger" />
              </div>
              <div>
                <Placeholder xs={1} bg="danger" />
              </div>
            </Placeholder>
          )}
        </div>
        {currentProduct.status === "idle" &&
          hostingProduct.productDetails &&
          loadingStatus === "idle" ? (
          <>
            <CheckboxNewHosting
              hostingProduct={hostingProduct}
              setHostingProduct={setHostingProduct}
              productGroup={productGroup}
              currentProduct={currentProduct}
              termin={termin}
            />

            {(isEligibleForFreeDomain || hostingProduct.pid === 1115) && (
              <div className="alert alert-info mt-2 p-3">
                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2">
                  {/* Judul - Dynamic based on eligibility */}
                  <div className="fw-bold text-center text-md-start" >
                    {(() => {
                      const isEligible = hostingProduct.pid === 1115 ||
                        (termin === "annually" || termin === "biennially" || termin === "triennially");
                      return isEligible ? "Dapat domain gratis!" : "Mau domain gratis?";
                    })()}
                  </div>

                  {/* Konten Utama */}
                  <div className="flex-grow-1">
                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-wrap gap-2">
                      <span className="text-center text-md-start" >
                        {(() => {
                          const isEligible = hostingProduct.pid === 1115 ||
                            (termin === "annually" || termin === "biennially" || termin === "triennially");

                          if (isEligible) {
                            return hostingProduct.pid === 1115
                              ? "Hosting ini mendapatkan gratis domain selama 1 tahun."
                              : "Anda mendapatkan domain gratis selama 1 tahun.";
                          } else {
                            return "Pilih paket minimal 12 bulan.";
                          }
                        })()}
                      </span>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-free-domain">
                            {hostingProduct.pid === 1115
                              ? "Hosting ini mendapatkan gratis domain selama 1 tahun dengan berlangganan paket minimal 1 tahun."
                              : "Gratis domain selama 1 tahun dengan berlangganan paket minimal 1 tahun."
                            }
                            <br />
                            Pilih dari: <b>
                              {hostingProduct.pid === 1115
                                ? ".com, .my.id, .or.id, .web.id, .biz.id"
                                : Array.isArray(freeDomainExtensions) && freeDomainExtensions.length > 0
                                  ? freeDomainExtensions.join(', ')
                                  : '-'
                              }
                            </b>
                            <br />
                            Setelah tahun pertama, domain Anda akan diperpanjang dengan harga normal.
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon
                          icon={faExclamationCircle}
                          className="ms-1"
                          style={{ fontSize: "12px", cursor: "help", color: "#FF6B35" }}
                        />
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <Placeholder as="div" animation="glow">
            <div className="row mt-3">
              <div className="col-12">
                <Placeholder xs={4} bg="dark" />
              </div>
              <div className="col-12 col-lg-6">
                <Placeholder xs={3} bg="danger" />
              </div>
              <div className="col-12 col-lg-6">
                <Placeholder xs={3} bg="danger" />
              </div>
            </div>
          </Placeholder>
        )}
        {showPaymentGateway ? (
          <>
            <div className="row mt-4">
              <div className="col-12 col-lg-8 d-flex  align-self-center">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="payment_gateway"
                    id="payment_gateway"
                    value="payment_gateway"
                    onChange={checkPaymentGateway}
                    checked={paymentGateway}
                  />
                  <label
                    htmlFor="payment_gateway"
                    className="ms-3 form-check-label fw-bold"
                    style={{ fontSize: "16px" }}
                  >
                    Addon Payment Gateway
                    <OverlayTrigger
                      trigger="click"
                      placement={"right"}
                      overlay={
                        <Tooltip>
                          Service Level Agreement Addon Payment Gateway dapat
                          ditemukan pada{" "}
                          <a href={`${process.env.REACT_APP_QWORDS_API}master-service-agreement/?tab-content=sla-addon-payment-gateway`}>
                            link ini
                          </a>
                        </Tooltip>
                      }
                    >
                      <span
                        className="d-inline-block ms-1 fw-bold"
                        style={{
                          backgroundColor: "#FFCF96",
                          cursor: "pointer",
                          borderRadius: "50%",
                          fontSize: "15px",
                          color: "#ee4d30",
                          padding: "0px 9px 1px 9px",
                        }}
                      >
                        !
                      </span>
                    </OverlayTrigger>
                  </label>
                </div>
              </div>
              <div className="col-12 col-lg-4 d-grid justify-content-end align-self-center">
                <p className="fw-bold mb-0 d-inline-block text-secondary">
                  <del>Rp50.000</del>
                </p>
                <span className="badge btn-cta p-2">GRATIS!</span>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {showPromo && (
          <PromoKaosTumbler
            price={total}
            billingcycle={termin}
          />
        )}
        {(query.pid && query.billingcycle === 'annually' && isPromoApplied) && (
          <div className="col-12 mt-5">
            <span className="text-success fw-semibold">
              Selamat! Anda mendapatkan Kode Voucher Flex WP Gratis
            </span>
          </div>
        )}
        <AddToCartButton
          onClick={addToCartHandler}
          disabled={hostingProduct.pid === 1115 && hostingTrialStatus?.hasTrial}
        />
      </CardWrapper>

      {/* Toggle Button untuk Domain Sections - DISABLED */}
      {(() => {
        const longTermCycles = ["annually", "biennially", "triennially"];
        const isLongTerm = longTermCycles.includes(termin);

        if (isLongTerm) {
          return (
            <div className="d-flex align-items-center justify-content-between mb-3">
              <label className="form-check-label text-muted fw-bold">
                Domain
              </label>
              {/* <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setShowDomainSections(!showDomainSections)}
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  borderRadius: "20px",
                  padding: "6px 16px"
                }}
              > */}
              <FontAwesomeIcon
                icon={showDomainSections ? faChevronUp : faChevronDown}
                className="ms-1"
                style={{ fontSize: "12px" }}
              />
              {/* </button> */}
            </div>
          );
        }
        return null;
      })()}

      {/* Domain Sections - ALWAYS SHOW */}
      {showDomainSections && (
        <>
          {location.pathname === "/migrasihosting" ? (
            <>
              <TransferDomain {...methodActivePropsWithToggle} extOption={extOption} />
              <ExistingDomain {...methodActivePropsWithToggle} extOption={extOption} />
            </>
          ) : (
            <>
              <RegisterDomain {...methodActivePropsWithToggle} ref={domainRef} extOption={extOption} />
              <TransferDomain {...methodActivePropsWithToggle} extOption={extOption} />
              <ExistingDomain {...methodActivePropsWithToggle} extOption={extOption} />
            </>
          )}
        </>
      )}
    </MainLayouts>
  );
};

export default Hosting